<template>
  <div class="fullWidth fRow jStart aCenter conventionItem">
    <span class="index" v-if="!deleteMode && loaded">{{indexs + 1}}</span>
    <i class="material-icons-round parentStateIcon">emoji_events
      <div class="tooltip">سرگروه</div>
    </i>
    <div class="fRow jStart aCenter growFull" v-if="!deleteMode && !resetPasswordMode && loaded">
      <div class="fCol jCenter aStart growFull">
        <input type="text" class="editable fullWidth"
          :disabled="!editMode"
          v-model="name"
          :placeholder="data.fullName">
        <span class="number">0{{data.mobile.slice(2, 12)}}</span>
      </div>
      <div class="parentState fCol jCenter aCenter">
        <label>دارای 4 زیرگروه</label>
        <span @click="showMoshaverChilds = true">ویرایش زیرگروه</span>
      </div>
      <i class="material-icons-round transition-fast"
        v-if="!editMode && false"
        @click="editMode = true">edit</i>
      <i class="material-icons-round transition-fast"
        v-if="editMode"
        @click="editMode = false">close</i>
      <switch-button
        @click.native="status = !status"
        v-if="!editMode"
        hint="وضعیت مشاور"
        :w="92"
        activeLabel="فعال"
        deactiveLabel="غیرفعال"
        :val="status" />
      <switch-button
        style="margin-right: 8px"
        @click.native="blocked = !blocked"
        v-if="!editMode"
        hint="مسدود کردن"
        :w="92"
        activeLabel="بلاک"
        deactiveLabel="بلاک"
        :val="blocked" />
      <i class="material-icons-round transition-fast"
        v-if="false"
        @click="showSession = true">privacy_tip</i>
      <i class="material-icons-round transition-fast"
        v-if="!editMode"
        @click="showKPIs = true">flag</i>
      <i class="material-icons-round transition-fast"
        v-if="!editMode"
        @click="goEdit">edit</i>
      <i class="material-icons-round transition-fast"
        v-if="!editMode"
        @click="resetPasswordMode = true">sync</i>
      <i class="material-icons-round red transition-fast"
        v-if="!editMode"
        @click="deleteMode = true">delete</i>
    </div>
    <div class="deleteDialoge fRow jStart aCenter fullWidth"
      v-if="deleteMode && !loading">
      <span class="growFull">آیا از حذف آیتم مطمئنید؟</span>
      <div class="fRow jStart aCenter bt red"
        @click="deleteConsulant">
        <i class="material-icons-round">delete</i>
        <label>حذف مشاور</label>
      </div>
      <i class="material-icons-round"
        @click="deleteMode = false">close</i>
    </div>
    <div class="deleteDialoge fRow jStart aCenter fullWidth"
      v-if="resetPasswordMode && !loading">
      <span class="growFull">آیا مایل به ارسال پسورد جدید هستید؟</span>
      <div class="fRow jStart aCenter bt green"
        @click="resetPassword">
        <i class="material-icons-round">sync</i>
        <label>ارسال پسورد جدید</label>
      </div>
      <i class="material-icons-round"
        @click="resetPasswordMode = false">close</i>
    </div>
    <div class="fRow jCenter aCenter fullWidth"
      style="padding: 16px 0"
      v-if="loading">
      <p-bar
        :loading="loading"
        :mini="true"
        :notYet="notYet"
        :noContent="noContent"
        :notFound="notFound"
        :error="error" />
    </div>
    <sessions v-if="false" @close="showSession = false" />
    <moshaver-kpi v-if="showKPIs"
      :data="data"
      @close="showKPIs = false" />
    <moshaver-childs v-if="showMoshaverChilds"
      :data="data"
      @close="showMoshaverChilds = false" />
  </div>
</template>

<script>
import axios from 'axios';
import pBar from '@/components/pBar.vue';
import errorHandler from '@/mixins/mixin';
import makeToast from '@/mixins/makeToast';
import SwitchButton from '@/components/SwitchButton.vue';
import Sessions from '@/components/Sessions.vue';
import MoshaverKpi from '@/components/MoshaverKpi.vue';
import MoshaverChilds from '@/components/MoshaverChilds.vue';

export default {
  props: ['data', 'indexs'],
  mixins: [errorHandler, makeToast],
  data() {
    return {
      baseURL: this.$store.state.baseUrl,
      V: this.$store.state.apiVersion,
      editMode: false,
      deleteMode: false,
      resetPasswordMode: false,
      // modes ↓
      loading: false,
      noContent: false,
      notFound: false,
      error: false,
      notYet: false,
      loaded: true,
      modeMsg: '',
      // modes ↑
      name: '',
      status: true,
      blocked: false,
      showSession: false,
      showKPIs: false,
      showMoshaverChilds: false,
    };
  },
  methods: {
    editClassification() {
      if (this.canSave) {
        this.setMode('loading');
        const reqUrl = `${this.baseURL}/api/v${this.V}/Questions/classification/${this.data.id}`;
        axios({
          method: 'put',
          url: reqUrl,
          headers: {
            Authorization: this.$authObeject.authToken(),
          },
          data: {
            name: this.name,
          },
        }).then((response) => {
          if (response.data.isSuccess) {
            this.setMode('loaded');
          } else {
            this.setMode('loaded');
            this.makeToast('error', 'مشکلی پیش آمده، دوباره تلاش کنید', 3000);
          }
          this.$emit('refresh');
          this.editMode = false;
        }, (error) => {
          this.makeToast('error', this.errorHandler(error), 3000);
          this.editMode = false;
          // console.log(error);
        }).catch(() => {
          this.makeToast('error', 'در صورت درستی اتصال به اینترنت، با تیم فنی تماس بگیرید', 3000);
          this.editMode = false;
        });
      } else {
        this.makeToast('error', 'ابتدا نام طبقه بندی را ویرایش کنید', 3000);
      }
    },
    deleteConsulant() {
      if (true) {
        this.setMode('loading');
        const reqUrl = `${this.baseURL}/api/v${this.V}/Consultants/${this.data.id}`;
        axios({
          method: 'delete',
          url: reqUrl,
          headers: {
            Authorization: this.$authObeject.authToken(),
          },
        }).then((response) => {
          if (response.data.isSuccess) {
            this.setMode('loaded');
          } else {
            this.setMode('loaded');
            this.makeToast('error', response.data.message, 3000);
          }
          this.$emit('refresh');
          this.deleteMode = false;
        }, (error) => {
          this.makeToast('error', this.errorHandler(error), 3000);
          this.setMode('loaded');
          this.deleteMode = false;
          // console.log(error);
        }).catch(() => {
          this.makeToast('error', 'در صورت درستی اتصال به اینترنت، با تیم فنی تماس بگیرید', 3000);
          this.setMode('loaded');
          this.deleteMode = false;
        });
      }
    },
    setMode(m, msg) {
      this.noContent = false;
      this.loading = false;
      this.notYet = false;
      this.error = false;
      this.loaded = false;
      this.modeMsg = '';
      switch (m) {
        case 'loading': {
          this.loading = true;
          break;
        }
        case 'loaded': {
          this.loaded = true;
          break;
        }
        case 'error': {
          this.modeMsg = msg;
          this.error = true;
          break;
        }
        case 'notYet': {
          this.notYet = true;
          break;
        }
        case 'noContent': {
          this.noContent = true;
          break;
        }
        default:
          break;
      }
    },
    resetPassword() {
      console.log('reset password');
    },
    goEdit() {
      this.$emit('edit', this.data);
    },
  },
  components: {
    pBar,
    SwitchButton,
    Sessions,
    MoshaverKpi,
    MoshaverChilds,
  },
  watch: {
    editMode() {
      if (this.editMode) {
        this.name = this.data.title;
      } else {
        this.name = '';
      }
    },
  },
  computed: {
    canSave() {
      return this.name !== '' && this.name !== this.data.title;
    },
  },
  mounted() {
    this.$nextTick(() => {
      // this.name = this.data.title;
      // console.clear();
    });
    // console.warn(this.data);
  },
};
</script>

<style lang="scss" scoped>
.conventionItem {
  position: relative;
  input:disabled {
    background-color: rgba($color: #000000, $alpha: 0);
    border-bottom: solid 1px rgba($color: #000000, $alpha: 0.0);
  }
  input {
    border-width: 0;
    outline: none;
    padding: 2px 0;
    margin-right: 8px;
    font-size: 15px;
    font-weight: 500;
    border-bottom: solid 1px rgba($color: #000000, $alpha: 0.15);
  }
  input:focus {
    border-bottom: solid 1px rgba($color: #000000, $alpha: 0.25);
    padding: 8px 0;
    margin-right: 16px;
  }
  span.number {
    padding: 0px 8px;
    font-size: 10px;
    letter-spacing: 1px;
  }
  span.index {
    padding: 0px 8px;
    font-size: 10px;
    width: 20px;
    text-align: center;
  }
  .deleteDialoge {
    border: solid 2px var(--themeRed);
    padding: 8px;
    border-radius: 24px 8px 8px 24px;
    .bt {
      padding: 4px 8px;
      border-radius: 16px;
      cursor: pointer;
      * {
        pointer-events: none;
      }
      i {
        margin: 0 !important;
        color: var(--invertText);
      }
      label {
        margin: 0 8px;
        font-size: 12px;
        color: var(--invertText);
      }
    }
    .bt.green {
      background-color: var(--themeGreen);
    }
    .bt.red {
      background-color: var(--themeRed);
    }
  }
  ::placeholder {
    color: var(--darkText);
    opacity: 1; /* Firefox */
  }
  :-ms-input-placeholder { /* Internet Explorer 10-11 */
    color: var(--darkText);
  }
  ::-ms-input-placeholder { /* Microsoft Edge */
    color: var(--darkText);
  }
  i {
    font-size: 16px;
    cursor: pointer;
    padding: 8px;
    border-radius: 50%;
    background-color: rgba($color: #000000, $alpha: 0.02);
    color: #var(--normalText);
    margin-right: 8px;
  }
  i.red {
    background-color: var(--themeRed) !important;
    color: var(--invertText) !important;
  }
  i.green {
    background-color: var(--themeGreen) !important;
    color: var(--invertText) !important;
  }
  i:hover {
    box-shadow: 0 0 0 2px rgba($color: #000000, $alpha: 0.25);
  }
}
.parentStateIcon {
  position: relative;
  color: var(--themeOrange) !important;
  background-color: rgba($color: #000000, $alpha: 0.75) !important;
  text-shadow: 0 1px 0 rgba($color: #000000, $alpha: 0.85);
  .tooltip {
    opacity: 0;
    pointer-events: none;
    position: absolute;
    top: 50%;
    right: 80%;
    transform: translate(0%, -50%);
    background-color: var(--normalText);
    color: var(--invertText);
    font-size: 12px;
    transition: all ease-in-out 0.15s;
    box-shadow: 16px 0 16px -8px rgba($color: #000000, $alpha: 0.85);
    border-radius: 24px;
    padding: 4px 12px;
  }
}
.parentStateIcon:hover {
  .tooltip {
    opacity: 1;
  }
}
.parentState {
  width: 132px;
  label {
    font-size: 10px;
    margin-bottom: 4px;
  }
  span {
    padding: 8px 12px;
    border-radius: 16px;
    color: var(--darkText);
    font-size: 12px;
    cursor: pointer;
    line-height: 1;
    transition: all ease-in-out 0.2s;
    background-color: var(--themeGreen2);
  }
  span:hover {
    background-color: var(--themeGreen);
    color: var(--invertText);
  }
}
</style>
